module.exports = __webpack_public_path__ + "img/thumb_29.8ceaae26.jpg";